import { useAuthStore } from '../stores/auth'
import { ROLES } from '../constants/roles'

function isTeacherRole(role?: string | null): boolean {
  return (role || '').trim().toLowerCase() === ROLES.TEACHER
}

/**
 * OTP / teacher accounts: no session-expiration modals; they stay signed in until logout
 * (access token still refreshes via cookies + API like other roles).
 */
export function isTeacherSession(): boolean {
  try {
    const auth = useAuthStore()
    if (isTeacherRole(auth.currentUser?.role)) return true
  } catch {
    /* Pinia inactive in rare contexts */
  }
  if (typeof localStorage === 'undefined') return false
  try {
    const raw = localStorage.getItem('currentUser')
    if (!raw) return false
    const u = JSON.parse(raw) as { role?: string }
    return isTeacherRole(u?.role)
  } catch {
    return false
  }
}
